import React, { useState } from "react";
import { Col, Collapse, Row, Table, TableColumnsType, message } from "antd";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import MoyasarForm from "../../../../components/Moyasar/MoyasarForm";
import { setSponsorShipBookingId } from "../../../../apis/slices/moyasarSlice";
import { checkSponsorBooking } from "../../../../apis/actions/sponsor.actions";
import { useTranslation } from "react-i18next";

interface Props {
  requests: any;
}

const SponsorBookingOverview = ({ requests }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const [selectedElement, setSelectedElement] = useState<any>(null);
  const [displayMoyasar, setDisplayMoyasar] = useState<boolean>(false);
  const [checkingId, setCheckingId] = useState<number | null>(null);
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);

  const openMoyasar = async (el: any) => {
    setCheckingId(el.id);
    try {
      const bookings = await dispatch(
        checkSponsorBooking({ sponsor_id: OtpId })
      ).unwrap();
      const booking = (bookings || []).find((b: any) => b.id === el.id);
      if (booking?.state !== "in_progress") {
        message.error("تغيرت حالة الحجز، لم يعد متاحًا للدفع");
        return;
      }
      setDisplayMoyasar(true);
      setSelectedElement(booking);
      dispatch(setSponsorShipBookingId(booking.id));
    } catch (error) {
      message.error("حدث خطأ ما! يرجى المحاولة لاحقاً");
    } finally {
      setCheckingId(null);
    }
  };

  const columns: TableColumnsType<any> = [
    {
      title: "المستفيد",
      dataIndex: "partner_id",
    },
    {
      title: "نوع الكفالة",
      dataIndex: "sponsorship_type",
      render: (sponsorship_type: string) => (
        <span>{t(`available_sponsorship_type.${sponsorship_type}`)}</span>
      ),
    },
    {
      title: "مبلغ الكفالة",
      dataIndex: "sponsorship_amount",
    },
    {
      title: "عدد الأشهر",
      dataIndex: "month_number",
    },
    {
      title: "المبلغ الإجمالي",
      dataIndex: "total_amount",
    },
    {
      title: "تاريخ بداية الكفالة",
      dataIndex: "sponsorship_start_date",
      render: (sponsorship_start_date: any) => (
        <span className="takaful--service-request-span">
          {sponsorship_start_date !== false && sponsorship_start_date
            ? dayjs(sponsorship_start_date, "YYYY-MM-DD").format("YYYY/MM/DD")
            : ""}
        </span>
      ),
    },
  ];
  return (
    <div className="takaful--collapse-profile-container">
      <div
        className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services  `}
      >
        <Collapse.Panel
          showArrow={false}
          key="0"
          className=" takaful--collapse-label-panel"
          header={
            <div className="takaful--header-profile-container">
              <Row
                className="takaful--content-profile-box1"
                style={{ marginBottom: "0" }}
              >
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={24}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    رقم الحجز
                  </p>
                </Col>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    اخر أجل للدفع
                  </p>
                </Col>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    المبلغ الإجمالي
                  </p>
                </Col>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={12}
                  xs={24}
                  className="takaful--col-content takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    المبلغ المدفوع
                  </p>
                </Col>
              </Row>
            </div>
          }
        ></Collapse.Panel>
      </div>
      <Collapse
        className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
        accordion
        defaultActiveKey={["0"]}
      >
        {requests?.map((element: any, index: number) => (
          <Collapse.Panel
            className="takaful--header-profile-Panel takaful--collapse-label-panel"
            key={index}
            header={
              <div className="takaful--header-profile-container">
                <Row
                  className="takaful--content-profile-box1"
                  style={{ marginBottom: "0" }}
                >
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={0}
                    xs={0}
                    className="takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.name}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={10}
                    xs={10}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      اخر أجل للدفع
                    </p>
                  </Col>
                  <Col
                    xxl={6}
                    xl={6}
                    lg={6}
                    md={6}
                    sm={14}
                    xs={14}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {dayjs(element?.payment_deadline).format(
                        "YYYY/MM/DD HH:mm"
                      )}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={10}
                    xs={10}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المبلغ الإجمالي
                    </p>
                  </Col>
                  <Col
                    xxl={5}
                    xl={5}
                    lg={5}
                    md={5}
                    sm={14}
                    xs={14}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.total_amount}
                    </span>
                  </Col>
                  <Col
                    xxl={0}
                    xl={0}
                    lg={0}
                    md={0}
                    sm={10}
                    xs={10}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <p className="takaful--content-services-request-p">
                      المبلغ المدفوع
                    </p>
                  </Col>
                  <Col
                    xxl={3}
                    xl={3}
                    lg={4}
                    md={4}
                    sm={14}
                    xs={14}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <span className="takaful--content-services-request-span">
                      {element?.paid_amount}
                    </span>
                  </Col>
                  <Col
                    xxl={4}
                    xl={4}
                    lg={4}
                    md={4}
                    sm={24}
                    xs={24}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    className="takaful--col-content takaful--content-profile-col"
                  >
                    <PrimaryButton
                      className="takaful--sponsor-booking-btnn"
                      title="سداد"
                      loading={checkingId === element?.id}
                      disabled={checkingId !== null}
                      onClick={(e: any) => {
                        e.stopPropagation();
                        openMoyasar(element);
                      }}
                    />
                  </Col>
                </Row>
              </div>
            }
          >
            <Row
              className={`takaful--content-profile-box1 takaful--row-content-booking-sponsor`}
              gutter={[16, 24]}
            >
              <Col
                xxl={0}
                xl={0}
                lg={0}
                md={0}
                sm={5}
                xs={12}
                className="takaful--content-profile-col"
              >
                <p className="takaful--content-services-request-p">رقم الحجز</p>
              </Col>
              <Col
                xxl={0}
                xl={0}
                lg={0}
                md={0}
                sm={18}
                xs={12}
                className="takaful--content-profile-col"
              >
                <span className="takaful--content-services-request-span takaful--color-span">
                  {element?.name}
                </span>
              </Col>
            </Row>

            <Row className={`takaful--content-profile-box1`} gutter={[16, 24]}>
              <React.Fragment>
                <Col
                  xxl={5}
                  xl={5}
                  lg={5}
                  md={5}
                  sm={5}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <p className="takaful--content-services-request-p">
                    تاريخ الحجز
                  </p>
                </Col>
                <Col
                  xxl={18}
                  xl={18}
                  lg={18}
                  md={18}
                  sm={18}
                  xs={12}
                  className="takaful--content-profile-col"
                >
                  <span className="takaful--content-services-request-span takaful--color-span">
                    {element?.date
                      ? dayjs(element?.date, "YYYY-MM-DD").format("YYYY/MM/DD")
                      : ""}
                  </span>
                </Col>
                <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Table
                    className="takaful--sponsor-table"
                    dataSource={element?.sponsorship_booking_line_ids}
                    columns={columns}
                    pagination={false}
                    scroll={{ x: "max-content" }}
                    locale={{
                      emptyText: "لا يوجد حجوزات",
                    }}
                  />
                </Col>
              </React.Fragment>
            </Row>
          </Collapse.Panel>
        ))}
      </Collapse>
      <MoyasarForm
        amount={
          selectedElement
            ? selectedElement?.total_amount - selectedElement?.paid_amount
            : 0
        }
        description="Takaful"
        open={displayMoyasar}
        handleClose={() => setDisplayMoyasar(false)}
      />
    </div>
  );
};

export default SponsorBookingOverview;
